export function fixManuallyEnteredColor(color) {
  color = _.trim(color || '');
  if (color) {
    if (color.indexOf('#') != 0) {
      color = '#' + color;
    }
    if (color.length == 4) {
      // convert shorthand hex
      color = color.replace(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i, (str, m1, m2, m3) => {
        return `#${m1}${m1}${m2}${m2}${m3}${m3}`;
      });
    }
    if (color.length != 7) {
      // otherwise just pad with black colorspace and trim to length
      color = (color + '000000').substring(0, 7);
    }
    if (!color.match(/^#[0-9a-f]{6}$/i)) {
      throw new Error('invalid color');
    }
  }
  return color;
}

angular.module('app.directives').directive('boxcastColorPicker', function ($rootScope, toaster) {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      defaultColor: '@',
    },
    link: function (scope, element, attrs, ngModelCtrl) {
      if (!scope.ngModel) {
        scope.ngModel = scope.defaultColor;
      }
      scope.select = function (value) {
        ngModelCtrl.$modelValue = value;
        ngModelCtrl.$viewValue = value;
        ngModelCtrl.$render();
        scope.ngModel = value;
        scope.isopen = false;
      };
      scope.onBlurColorPicker = function (api, color, $event) {
        // After user input, validate and coerce to sane string prior to selecting
        try {
          scope.select(fixManuallyEnteredColor(color));
        } catch (e) {
          console.error(e);
          toaster.pop('warning', `Invalid color ${color}. It should be in the format of #ABCDEF.`);
        }
      };
      scope.onChangeColorPicker = function (api, color, $event) {
        // Don't validate here; this is fired while typing
        scope.select(color);
      };
    },
    controller: function ($scope, $rootScope) {
      const { account } = $rootScope;
      $scope.isopen = false;
      if (account.extra_features.scoreboard_spectrum) {
        $scope.useSpectrumPalette = true;
        $scope.colors = SPECTRUM_COLOR_PALETTE;
      }
    },
    template: `
        <color-picker ng-hide="useSpectrumPalette"
                      ng-model="ngModel"
                      options="{
                        format: 'hexString',
                        alpha: false,
                        swatch: true,
                        swatchBootstrap: true,
                        preserveInputFormat: true,
                        allowEmpty: true,
                        inputClass: 'form-control',
                      }"
                      event-api="{
                        onChange: onChangeColorPicker,
                        onBlur: onBlurColorPicker,
                      }"
        ></color-picker>

        <div ng-show="useSpectrumPalette" class="btn-group btn-block" uib-dropdown is-open="isopen">
          <button type="button" class="btn btn-default btn-block" uib-dropdown-toggle style="text-align:left">
            <color-swatch color="ngModel" label=""></color-swatch>
            {{colors[ngModel] || ngModel || 'Not Selected'}}
            <i class="pull-right fa fa-caret-down"></i>
          </button>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="width:100%">
            <li role="menuitem" ng-repeat="(c, label) in ::colors">
              <a href ng-click="select(c)">
                <color-swatch color="c" label="" style="display:inline-block;max-width:50px;margin-right:10px;overflow:hidden"></color-swatch>
                {{::label}}
              </a>
            </li>
          </ul>
        </div>
      `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/boxcast-color-picker.js